import React, { useMemo } from "react";

function GlobalParticles() {
  const particles = useMemo(() =>
    Array.from({ length: 150 }, () => ({
      top: Math.random() * 100,
      left: Math.random() * 100,
      size: 1.2 + Math.random() * 3.5,
      delay: Math.random() * -20,
      duration: 10 + Math.random() * 20,
      gold: Math.random() > 0.3,
    })), []);

  return (
    <div className="global-particles-overlay">
      <div className="global-atmosphere"></div>
      {particles.map((p, i) => (
        <span
          key={i}
          className={`global-particle ${p.gold ? 'is-gold' : ''}`}
          style={{
            top: `${p.top}%`,
            left: `${p.left}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
          }}
        ></span>
      ))}
      <style>{`
        .global-particles-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100% !important;
          height: 100% !important;
          pointer-events: none;
          z-index: 0; /* À frente do fundo, atrás do conteúdo */
          overflow: hidden;
          background: transparent;
        }

        .global-atmosphere {
           position: absolute;
           top: 0; left: 0; width: 100%; height: 100%;
           background: radial-gradient(circle at 70% 20%, rgba(228, 168, 122, 0.15) 0%, transparent 50%),
                       radial-gradient(circle at 10% 90%, rgba(201, 139, 88, 0.15) 0%, transparent 50%);
        }

        .global-particle {
          position: absolute;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
          animation: globalFloatUp linear infinite;
          will-change: transform;
          transform: translateZ(0);
        }

        .global-particle.is-gold {
          background: rgba(228, 168, 122, 0.9);
          box-shadow: 0 0 15px rgba(228, 168, 122, 0.6);
        }

        @keyframes globalFloatUp {
          0% { transform: translateY(100vh) translateX(0); opacity: 0; }
          10% { opacity: 0.6; }
          90% { opacity: 0.6; }
          100% { transform: translateY(-10vh) translateX(40px); opacity: 0; }
        }
      `}</style>
    </div>
  );
}

export default GlobalParticles;
